export const currencyFormatter = new Intl.NumberFormat(undefined, { 
    currency: "krw",
    style: "currency",
    minimumFractionDigits: 0
})